export const baseUrl = process.env.REACT_APP_API_URL;
export const baseUrlDjango = process.env.REACT_APP_API_DJANGO_URL;
export const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const razorPayKey = process.env.REACT_APP_RAZORPAY_PUBLIC_KEY;
export const ENV = process.env.REACT_APP_ENV;
export const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_KEY;
export const PROTECT_GROUP_KEY = process.env.REACT_APP_PROTECT_GROUP_VENDOR_KEY;
export const selfServiceUrl = process.env.REACT_APP_SELF_SERVICE_URL;
export const magicLinkUrl = process.env.REACT_APP_MAGICLINK_URI;
export const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
export const bookingIdHashKey = process.env.REACT_APP_BOOKING_ID_HASH_KEY;
export const hashAlgorithm = process.env.REACT_APP_ALGORITHM;

